import { createAction } from '@ngrx/store';

export const SupportActions = {
  supportRequestCreated: createAction('[Support] request created'),
};
